import { connect } from 'react-redux';
import { AllJobStatus } from 'src/components/JobStatus/AllJobStatus';
import { hideConfirmBonusJobMessage } from 'src/reducers/employees/employeeBonus';

const mapDispatchToProps = (dispatch, ownProps) => ({
  hideJobMessage: () => {
    dispatch(hideConfirmBonusJobMessage(ownProps.task.jobId));
  }
});
export default connect(null, mapDispatchToProps)(AllJobStatus);
